import _changelog from '@/changelog'
import moment from 'moment'

const initial = {
  changelog() {
    // sort by timestamp
    _changelog.sort((a, b) => {
      return b.timestamp - a.timestamp
    })
    const lastseen = localStorage.getItem('last_changelog_seen') || 0
    // set new only those of today.
    for (let i in _changelog) {
      let log = _changelog[i]
      if (moment().diff(moment(log.timestamp, 'X'), 'days') <= 0) {
        // new, only if the last seen in local storage is older
        log.new = lastseen < log.timestamp
      }
    }
    return _changelog
  }
}

const state = {
  changelog: initial.changelog(),
}

const actions = {
  seenAll({ state }) {
    return new Promise((resolve) => {
      state.changelog.map(log => log.new = false)
      localStorage.setItem('last_changelog_seen', state.changelog[0].timestamp)
      resolve()
    })
  },
}

const getters = {
  changelog: state => state.changelog,
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
}
